<template>
  <div>
    <modal-crear-editar
      :configuracion="configuracion_modal"
      @realizado="restablecer_inputs"
    ></modal-crear-editar>
    <tablita
      :cols="columnas"
      @analisis_laboratorio="analisis_laboratorio($event)"
      @detalle="detalle($event)"
      @cargar="cargar($event)"
      @cargar_url="cargar_url($event)"
      @nuevo="crear"
      @editar="editar($event)"
      :configuracion="configuracion_tabla"
      @eliminar="eliminar($event)"
      @refresh="refrescar($event)"
    ></tablita>
    <vue-confirm-dialog></vue-confirm-dialog>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import ModalCrearEditar from "../../components/Modal/ModalEditarCrear";
import Tabla from "../../components/Tabla/Tabla";
//import lenguaje from '../../config/es_datatable.json'
export default {
  data: () => ({
    filter: "",
    columnas: [
      //{key:'numero_vuelta',label:'N° Vuelta',busqueda:'',tipo:'string',searchable:true,path:'numero_vuelta'},
      {
        key: "ingreso_vehiculo_porteria_id",
        label: "N° Vuelta",
        busqueda: "",
        tipo: "html",
        searchable: true,
        path: "ingreso_vehiculo_porteria",
      },
      {
        key: "codigo_ticket",
        label: "N° Ticket",
        busqueda: "",
        tipo: "string",
        searchable: true,
        path: "codigo_ticket",
      },
      {
        key: "sistema_pesaje_ticket_html",
        label: "Sistema Pesaje",
        busqueda: "",
        tipo: "html",
        searchable:false,
        path:"sistema_pesaje_ticket_html"
      },
      {
        key: "barco",
        label: "Barco",
        busqueda: "",
        tipo: "string",
        searchable: false,
        path: "barco",
      },
      {
        key: "muelle",
        label: "Muelle",
        busqueda: "",
        tipo: "string",
        searchable: false,
        path: "muelle",
      },
      {
        key: "numero_guias",
        label: "N° Guías",
        busqueda: "",
        tipo: "string",
        searchable: true,
        path: "numero_guias",
      },
      //{key:'fecha_hora_bruto',label:'Fecha Ingreso',busqueda:'',tipo:'datetime',searchable:true,path:'fecha_hora_bruto'},
      //{key:'fecha_hora_tara',label:'Fecha Tara',busqueda:'',tipo:'datetime',searchable:true,path:'fecha_hora_tara'},
      {
        key: "fecha_hora_ticket",
        label: "Fecha Ticket",
        busqueda: "",
        tipo: "datetime",
        searchable: true,
        path: "fecha_hora_ticket",
      },
      {
        key: "mp_tipos_id",
        label: "Materia Prima",
        busqueda: "",
        tipo: "select",
        searchable: true,
        path: "materia_prima_texto",
        opciones: [],
        valor_opcion: "id",
        label_opcion: "nombre",
      },
      //{key:'conductores_id',label:'Conductor',busqueda:'',tipo:'select',searchable:true,path:'conductor.nombre_completo',opciones:[],valor_opcion:'id',label_opcion:'nombre_completo'},
      {
        key: "conductores_id",
        label: "Conductor",
        busqueda: "",
        tipo: "select-loadable",
        ruta: "/conductores",
        parametro: "nombre_completo",
        searchable: true,
        path: "conductor.nombre_completo",
        opciones: [],
        valor_opcion: "id",
        label_opcion: "nombre_completo",
        width: 250,
      },
      {
        key: "transportes_id",
        label: "Transporte",
        busqueda: "",
        tipo: "select-loadable",
        ruta: "/transportes",
        parametro: "patente",
        searchable: true,
        path: "transporte.patente",
        opciones: [],
        valor_opcion: "id",
        label_opcion: "patente",
      },
      //{key:'transportes_id',label:'Transporte',busqueda:'',tipo:'select',searchable:true,path:'transporte.patente',opciones:[],valor_opcion:'id',label_opcion:'patente'},
      {
        key: "ciclo_ticket",
        label: "Ciclo Ticket",
        busqueda: "",
        tipo: "select",
        searchable: true,
        path: "ciclo",
        opciones: [],
        valor_opcion: "id",
        label_opcion: "nombre",
      },
      {
        key: "cantidad_guias",
        label: "Total Guías",
        busqueda: "",
        tipo: "number",
        searchable: false,
        path: "cantidad_guias",
      },
      {
        key: "estado_pesaje",
        label: "Estado Pesaje",
        busqueda: "",
        tipo: "html_select",
        searchable: true,
        path: "estado_ticket_html",
        opciones: [
          { id: 1, nombre: "PENDIENTE" },
          { id: 2, nombre: "FINALIZADO" },
        ],
        valor_opcion: "id",
        label_opcion: "nombre",
      },
      {
        key: "tiene_analisis",
        label: "Tiene Análisis",
        busqueda: "",
        tipo: "html",
        searchable: false,
        path: "tiene_analisis_html",
        icono: "fas fa-clipboard-check",
        style: "color:#3c6591;cursor:pointer; font-size:1.5em;",
      },
    ],
    botones: [
      //{label:'Editar',clase:'btn-warning',evento:'editar',icono:'fa fa-pen'},
      {
        label: "Detalle",
        clase: "btn-primary",
        evento: "detalle",
        icono: "fas fa-search-plus",
      },
    ],
    botones_restringidos: [],
    lista: [],
    links: [],
    ciclos_ticket: [],
    conductores: [],
    transportes: [],
    materias_primas: [],
    inputs: [
      {
        cols: 4,
        tipo: "numero",
        key: "codigo_ticket",
        valor: "",
        label: "N° Ticket (*)",
      },
      {
        cols: 4,
        tipo: "select",
        key: "ciclo_ticket",
        valor: "",
        label: "Ciclo ticket (*)",
        opciones: [],
        valor_opcion: "id",
        label_opcion: "nombre",
      },
    ],
    configuracion_modal: {
      titulo: "Registrar Ticket",
      ancho: "xl",
      ruta: "/tickets",
      tipo_ruta: "post",
      titulo_boton: "Crear",
      clase_boton: "btn-success",
    },
    configuracion_tabla: {
      titulo: "Listado de Tickets",
      titulo_boton: "Crear Ticket",
      clase_boton: "btn-primary",
      btn_nuevo: false,
    },
    pagina_actual: "",
    /* columns: [
            {label: 'Rut', field: 'rut'},
            {label: 'Nombre', field: 'nombre', headerClass: 'class-in-header second-class'}
        ], */
  }),
  mounted() {
    this.inicializar_tabla({
      columnas: [],
      lista: [],
      links: [],
      botones: [],
      botones_restringidos: [],
    });
    this.$emit("spinner", true);
    let storage = localStorage.getItem(this.path);
    if (storage) {
      storage = JSON.parse(storage);
      this.columnas.forEach((col) => {
        col.busqueda = storage.columnas.find((c) => c.key == col.key).val;
      });
    }
    console.log("storage", storage);
    this.cargar_ciclos();

    if (
      this.verificar_permiso("ROMANA_TicketRomanaController_eliminar_ticket")
    ) {
      this.botones_restringidos.push({
        label: "Eliminar",
        clase: "btn-danger",
        evento: "eliminar",
        icono: "fas fa-trash",
        permiso: "ROMANA_TicketRomanaController_eliminar_ticket",
      });
    }

    if (
      this.verificar_permiso(
        "ROMANA_TicketRomanaController_crear_actualizar_analisis_ticket"
      )
    ) {
      this.botones_restringidos.push({
        label: "A. Laboratorio",
        clase: "btn-warning",
        evento: "analisis_laboratorio",
        icono: "fas fa-flask",
        permiso:
          "ROMANA_TicketRomanaController_crear_actualizar_analisis_ticket",
        path_condicion: "mostrar_laboratorio",
      });
    }
  },
  methods: {
    refrescar() {
      localStorage.removeItem(this.path);
      this.columnas.forEach((c) => {
        if (
          [
            "string",
            "number",
            "select",
            "select-loadable",
            "select-loadable-dependiente",
            "datetime",
            "html",
            "html_select",
          ].includes(c.tipo)
        ) {
          c.busqueda = "";
        }

        if (["multiselect"].includes(c.tipo)) {
          c.busqueda = [];
        }
      });
      this.$emit("cargar");
    },
    async cargar_ciclos() {
      await this.axios
        .get(`${this.api}/ciclos_ticket`, this.cabeceras_json)
        .then((res) => {
          this.ciclos_ticket = res.data.data;
          this.$set(this.columnas[10], "opciones", this.ciclos_ticket);
          //this.$set(this.inputs[4],'opciones',this.ciclos_ticket);
          //console.log('ciclos',res.data.data);
        })
        .catch((e) => {
          //console.log(e);
        });
      this.cargar_materias_primas();
    },

    async cargar_materias_primas() {
      await this.axios
        .get(`${this.api}/mps_tipo?limit=9999999`, this.cabeceras_json)
        .then((res) => {
          this.materias_primas = res.data.data.data;
          this.$set(this.columnas[7], "opciones", this.materias_primas);
          //this.$set(this.inputs[4],'opciones',this.ciclos_ticket);
          //console.log('ciclos',res.data.data);
        })
        .catch((e) => {
          //console.log(e);$dets->count()
        });
      //this.cargar_conductores();
      //this.cargar('');
      this.$emit("cargar");
      //this.$emit("cargar",{columnas:this.columnas});
    },

    async cargar_conductores() {
      await this.axios
        .get(`${this.api}/conductores?limit=9999999`, this.cabeceras_json)
        .then((res) => {
          this.conductores = res.data.data.data;
          this.$set(this.columnas[7], "opciones", this.conductores);
          //this.$set(this.inputs[3],'opciones',this.ciclos_ticket);
          ////console.log('ciclos',res.data.data);
        })
        .catch((e) => {
          //console.log(e);
        });

      this.cargar_transportes();
    },

    async cargar_transportes() {
      await this.axios
        .get(`${this.api}/transportes?limit=9999999`, this.cabeceras_json)
        .then((res) => {
          this.transportes = res.data.data.data;
          this.$set(this.columnas[8], "opciones", this.transportes);
          //this.$set(this.inputs[3],'opciones',this.ciclos_ticket);
          ////console.log('ciclos',res.data.data);
        })
        .catch((e) => {
          //console.log(e);
        });
      //this.cargar('');
    },

    async cargar($event) {
      this.$emit("spinner", true);
      this.pagina_actual = `${this.api}/tickets${$event}`;
      this.lista = [];
      await this.axios
        .get(`${this.api}/tickets${$event}`, this.cabeceras_json)
        .then((res) => {
          this.lista = res.data.data.data;
          this.links = res.data.data.links;
          /* let config = {
                  columnas:this.columnas,
                  lista:this.lista,
                  links:this.links
                } */
          this.inicializar_tabla({
            columnas: this.columnas,
            lista: this.lista,
            links: this.links,
            botones: this.botones,
            botones_restringidos: this.botones_restringidos,
          });
          //this.$emit('generar',this.columnas,this.lista);
          ////console.log('listado',res.data.data.data);
          //$('#empresas').DataTable().draw();
        })
        .catch((e) => {
          //alert(e);
        });
      this.$emit("spinner", false);
    },
    async cargar_url(url) {
      if (url) {
        this.$emit("spinner", true);
        this.pagina_actual = url;
        await this.axios
          .get(url, this.cabeceras_json)
          .then((res) => {
            this.lista = res.data.data.data;
            this.links = res.data.data.links;
            ////console.log('listado',res.data.data.data);
            this.setear_lista({ lista: this.lista, links: this.links });
            //$('#empresas').DataTable().draw();
          })
          .catch((e) => {
            //alert(e);
          });
        this.$emit("spinner", false);
      }
    },
    crear() {
      this.setear_inputs(this.inputs);
      this.restablecer_inputs();
      this.configuracion_modal.ruta = `/tickets`;
      this.configuracion_modal.tipo_ruta = "post";
      this.configuracion_modal.titulo_boton = "Crear";
      this.configuracion_modal.clase_boton = "btn-success";

      this.$emit("abrir", { inputs: this.inputs });
    },
    editar(evento) {
      //console.log('evento',evento);
      let item = evento.item;
      this.inputs.forEach((i) => {
        //recorrido del objeto a editar
        Object.keys(item).forEach((key) => {
          let valor = item[key];
          if (i.key == key) {
            i.valor = valor;
          }
        });
      });
      this.setear_inputs(this.inputs);
      this.configuracion_modal.ruta = `/tickets/${evento.item.id}`;
      this.configuracion_modal.tipo_ruta = "put";
      this.configuracion_modal.titulo_boton = "Actualizar";
      this.configuracion_modal.clase_boton = "btn-warning";

      this.$emit("abrir");
    },
    restablecer_inputs() {
      this.cargar_url(this.pagina_actual);
      this.inputs.forEach((i) => {
        i.valor = "";
      });
      this.setear_inputs(this.inputs);
    },

    detalle(event) {
      //console.log(event);
      //router.push({ name: 'user', params: { userId: '123' } })
      //this.$router.push({path:`ticket/${event.item.id}`});
      this.$router.push({
        name: "ticket_detalle",
        params: { id: event.item.id },
      });
    },

    analisis_laboratorio(event) {
      this.$router.push({
        name: "ticket_analisis_lab",
        params: { id: event.item.id },
      });
    },

    async eliminar(event) {
      this.$confirm({
        title: `Esta a Punto de Eliminar el Ticket N° ${event.item.codigo_ticket}`,
        message: `Se Eliminará el Ticket, además de sus guías y otros datos relacionados. ¿desea eliminarlo de todas maneras?`,
        button: {
          no: "No",
          yes: "Si, Eliminar.",
        },
        /**
         * Callback Function
         * @param {Boolean} confirm
         */
        callback: async (confirm) => {
          if (confirm) {
            await this.axios
              .delete(
                `${this.api}/tickets/${event.item.id}`,
                this.cabeceras_json
              )
              .then((res) => {
                this.cargar("");
              })
              .catch((e) => {
                console.log(e);
              });
          }
        },
      });
    },
    ...mapActions(["inicializar_tabla", "setear_lista", "setear_inputs"]),
  },
  components: {
    "modal-crear-editar": ModalCrearEditar,
    tablita: Tabla,
  },
  computed: {
    ...mapState(["api", "cabeceras_json"]),
    query() {
      let string = "?";
      let and = "";
      let total = this.columnas.length - 1;
      this.columnas.forEach((c, index) => {
        if (index > 0 && string.length > 0) {
          and = "&";
        } else if (index == total) {
          and = "";
        }

        if (c.busqueda != "") {
          string += `${and}${c.key}=${c.busqueda}`;
        }
      });
      return string;
    },

    path() {
      return this.$router.currentRoute.path;
    },
  },
};
</script>
<style>
.form-control {
  height: calc(1em + 1.25rem + 5px);
}
</style>